import { ISite } from '@/Core.Service.Domain/Sites/Sites.Common/types/site.ts';
import { IEgaugeRegister } from '@/Core.Service.Domain/Monitors/Egauges/types/register';
import { IEgauge } from '@/Core.Service.Domain/Monitors/Egauges/types/egauge.ts';
import { IUnmappedRegisters } from '@/Core.Service.Domain/Monitors/Egauges/types/unmappedRegisters.ts';

const SET_SELECTED_SITE = (state: { selectedSite: ISite }, payload: ISite) => {
  state.selectedSite = payload;
};

const SET_REGISTRIES_BY_EGAUGE = (
  state: { registersList: IEgaugeRegister[] },
  payload: IEgaugeRegister[]
) => {
  state.registersList = payload;
};

const SET_UNMAPPED_REGISTERS = (
  state: { unmappedRegisters: IUnmappedRegisters },
  payload: IUnmappedRegisters
) => {
  state.unmappedRegisters = payload;
};

const SET_EGAUGE_INFO = (state: { egaugeInfo: IEgauge }, payload: IEgauge) => {
  state.egaugeInfo = payload;
};

export default {
  SET_SELECTED_SITE,
  SET_REGISTRIES_BY_EGAUGE,
  SET_EGAUGE_INFO,
  SET_UNMAPPED_REGISTERS,
};
